<div class="p-2">
  <h1 class="has-text-centered has-text-weight-semibold is-size-3">Questionnaire</h1>
  <h2 class="has-text-centered is-size-6 mt-2">
    Please complete the medical intake form below for our clinicians to prescribe your medication.
  </h2>
</div>
